import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { withClient } from '@deerplusofficial/pos-hoc';
import { mapState, getResult } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import actions from '../../actions';
import withQueryProducts from '../Queries/withQueryProducts';
import withCreateOrder from './withCreateOrder';
import withCancelOrder from './withCancelOrder';
import withCancelPreOrder from './withCancelPreOrder';

const {
  submit: { enable: enableSubmitOrder, disable: disableSubmitOrder },
} = actions.order;
const { edit: editOrderStep } = actions.orderStep;
const { edit: editReceipt } = actions.receipt;

export default () => Component =>
  fp.compose(
    withClient(),
    withQueryProducts(),
    withCreateOrder(),
    withCancelOrder(),
    withCancelPreOrder(),
    connect(
      mapState(['order', 'payment', 'receipt', 'preOrder']),
      { enableSubmitOrder, disableSubmitOrder, editReceipt, editOrderStep }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'withCheckout');

      onCheckout = async ({
        methodId,
        cashAmount: received_cash,
        cardNumber: card_number_last4,
        token: onetime_key,
      }) => {
        const {
          fetchProducts,
          enableSubmitOrder,
          disableSubmitOrder,
          editReceipt,
          editOrderStep,
          onOrderCreate,
          onOrderCancel,
          onPreOrderCancel,
          receipt: { orderId: receiptOrderId },
          payment: { id: paymentId },
          client: { POSApi, onError },
          order: { price, points, submitting },
          preOrder: { id: preOrderId },
        } = this.props;

        if (submitting) return;

        try {
          enableSubmitOrder();

          if (receiptOrderId || paymentId)
            await onOrderCancel({
              orderId: receiptOrderId,
              note: 'remove useless order.',
            });

          const { orderId, orderNumber } = await onOrderCreate();

          const {
            payment: { status, meta },
          } = getResult(
            await POSApi.post(`/orders/${orderId}/payments`, {
              amount: price - points,
              method_id: methodId,
              meta: JSON.stringify({
                received_cash,
                card_number_last4,
                onetime_key,
              }),
            })
          );

          if (status !== 100) {
            try {
              await POSApi.post(`/orders/${orderId}/cancel`, {
                note: `Payment status: ${status}`,
              });
            } catch (e) {
              onError(e);
            } finally {
              const { error } = JSON.parse(meta);
              throw new Error(error.message);
            }
          }

          if (_.size(preOrderId)) await onPreOrderCancel(preOrderId);

          editOrderStep('done');
          editReceipt({ orderNumber, orderId });
          fetchProducts();
        } catch (e) {
          onError(e);
        } finally {
          disableSubmitOrder();
        }
      };

      render() {
        return <Component {...this.props} onCheckout={this.onCheckout} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCheckout.js